import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewPlayIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="new-play-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4318 6.35501C13.1894 6.93458 13.1894 8.06542 12.4318 8.64499C10.1424 10.3965 7.58602 11.7771 4.85824 12.735L4.35991 12.91C3.40654 13.2448 2.39953 12.607 2.27046 11.6339C1.90985 8.91518 1.90985 6.08482 2.27046 3.36606C2.39953 2.39299 3.40654 1.7552 4.35992 2.09L4.85824 2.265C7.58602 3.22291 10.1424 4.60347 12.4318 6.35501ZM11.7308 7.74911C11.8956 7.62302 11.8956 7.37699 11.7308 7.25089C9.53739 5.57282 7.08819 4.25016 4.47482 3.33242L3.97649 3.15742C3.72831 3.07027 3.4431 3.23637 3.40636 3.51335C3.05872 6.13434 3.05872 8.86566 3.40636 11.4866C3.4431 11.7636 3.72831 11.9297 3.97649 11.8426L4.47482 11.6676C7.08818 10.7498 9.53739 9.42718 11.7308 7.74911Z"
      fill="currentColor"
    />
  </Icon>
);
